import React__default, { useState } from 'react';
import { Button } from '@deal/components';
import classnames from 'classnames';
import MessageBubble from '../../../MessageBubble/index.js';
import MessageBubbleText from '../../../MessageBubbleText/index.js';
import styles from './styles.css.js';
import ChevronUp from './chevron-up.svg.js';
import ChevronDown from './chevron-down.svg.js';
import { HowCuratedWorksBusinessMessageComponent } from './HowCuratedWorksBusinessMessage.generated.js';

var HowCuratedWorksBusinessMessage = function HowCuratedWorksBusinessMessage(_a) {
  var message = _a.message,
      myself = _a.myself,
      richCard = _a.richCard;

  var _b = useState(true),
      isCollapsed = _b[0],
      setIsCollapsed = _b[1];

  var leadId = richCard.leadId;
  return React__default.createElement(HowCuratedWorksBusinessMessageComponent, {
    variables: {
      leadId: leadId
    }
  }, function (_a) {
    var _b;

    var data = _a.data,
        loading = _a.loading;

    if (loading) {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Loading...");
    } else if (data && data.lead) {
      var category = data.lead.category;
      var categoryName = category ? category.singularDisplayName.toLowerCase() : null;
      return React__default.createElement(MessageBubble, {
        message: message,
        className: styles.message
      }, React__default.createElement("div", {
        className: classnames((_b = {}, _b[styles.listTitle] = !isCollapsed, _b))
      }, "Here's a quick reminder of how Curated works:"), !isCollapsed && React__default.createElement(React__default.Fragment, null, React__default.createElement("ul", {
        className: styles.list
      }, React__default.createElement("li", null, "We'll connect you directly to a vetted\xA0", categoryName, " expert. They will join this conversation."), React__default.createElement("li", null, "Your dedicated expert will put together a curated set of options based on your details, and work with you to find alternatives until it meets your exact requirements."), React__default.createElement("li", null, "When you're 100% happy with your recommendations, you'll be able to buy directly on our site.")), React__default.createElement("div", {
        className: styles.recap
      }, "If you want to add any additional details about what you're looking for, feel free to send a message below.")), React__default.createElement("div", {
        className: styles.seeMoreRow
      }, !isCollapsed ? React__default.createElement(Button, {
        variant: "primary-link",
        size: "xsmall",
        className: styles.showMore,
        onClick: function onClick() {
          return setIsCollapsed(true);
        }
      }, "Collapse Details ", React__default.createElement(ChevronUp, {
        className: styles.chevron
      })) : React__default.createElement(Button, {
        variant: "primary-link",
        size: "xsmall",
        className: styles.showMore,
        onClick: function onClick() {
          return setIsCollapsed(false);
        }
      }, React__default.createElement("div", null, "Expand All Details"), " ", React__default.createElement(ChevronDown, {
        className: styles.chevron
      }))));
    } else {
      return React__default.createElement(MessageBubbleText, {
        message: message,
        myself: myself
      }, "Error loading message!");
    }
  });
};

export default HowCuratedWorksBusinessMessage;
//# sourceMappingURL=index.js.map
